import React from "react";
import "../Dashboard.css";

const DashboardCard = ({ icon, title, onClick, badgeText }) => {
  return (
    <div className="dashboard-card" onClick={onClick}>
      <div className="left">{icon}</div>
      <div className="right">{title}</div>
      {badgeText && <div className="badge">{badgeText}</div>}
    </div>
  );
};

export default DashboardCard;
